import { Overlay } from '@angular/cdk/overlay';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    AfterViewInit,
    Component,
    effect,
    HostListener,
    OnInit,
    Renderer2, ViewChild,
    ViewEncapsulation,
    signal
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { ModalForgotPasswordComponent } from '../../login/modal-forgot-password/modal-forgot-password.component';
import { IDropDownMenu } from '../../shared/interfaces';
import { IGeneralTranslation } from '../../shared/interfaces/auth.interface';
import { Constants } from '../../shared/models/constants';
import { Defaults } from '../../shared/models/defaults';
import { Enums } from '../../shared/models/enums';
import { ModalService } from '../../shared/services/modal.service';
import { AuthService } from '../services/auth.service';
import { UserPersistenceService } from '../services/userPersistence.service';

import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { DomSanitizer } from '@angular/platform-browser';
import { isNullOrUndefined, error } from 'util';
import { DeviceDetectorService } from 'ngx-device-detector';

import { ModalChangePasswordComponent } from '../../login/modal-change-password/modal-change-password.component';
import { ModalLandingPagePreference } from '../../login/modal-landing-page-preference/modal-landing-page-preference.component';
import { ModalSignupComponent } from '../../login/modal-signup/modal-signup.component';
import { UserProfileService } from '../../login/user-profile/user-profile.service';
import { CommonDataService } from '../../project/services/commonData.service';
import { DocumentUploadDataService } from '../../project/services/documentUploadDataService';
import { ToolsHelperService } from '../../project/tools/tools-helper.service';
import { CommonService } from '../../shared/services/common.service';
import { ParentChildCommunicationService } from '../../shared/services/parent-child-communication.service';
import { ModalBrowserSupportComponent } from '../../shared/widgets';
import { CompactViewSwitchComponent } from '../../shared/widgets/compact-view/cvswitch.component';
import { DropdownMenuComponent } from '../../shared/widgets/dropdown-menu/dropdown-menu.component';
import { MobileFilemenuDropdownComponent } from '../../shared/widgets/mobile-specific/mobile-filemenu-dropdown/mobile-filemenu-dropdown.component';
import { MobileLanguageDropdownComponent } from '../../shared/widgets/mobile-specific/mobile-language-dropdown/mobile-language-dropdown.component';
import { MobileVersionDropdownComponent as MobileVersionDropdownComponent_1 } from '../../shared/widgets/mobile-specific/mobile-version-dropdown/mobile-version-dropdown.component';
import { ModalSessionTimeoutComponent } from '../../shared/widgets/modals/modal-session-timeout/modal-session-timeout.component';
import { NotificationDropdownComponent } from '../../shared/widgets/notification-dropdown/notification-dropdown.component';


@Component({
    selector: 'app-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [RouterLink, DropdownMenuComponent, RouterLinkActive, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MobileVersionDropdownComponent_1, MobileFilemenuDropdownComponent, MobileLanguageDropdownComponent, CompactViewSwitchComponent, NotificationDropdownComponent, MatMenuTrigger, MatMenu, MatMenuItem]
})
export class HeaderComponent implements OnInit, AfterViewInit {
    @ViewChild('MenuScrollBar', { static: false }) private myScrollContainer: any;
    @ViewChild('profileMenuTrigger', { read: MatMenuTrigger, static: false }) private profileMenuTrigger: MatMenuTrigger;
    @HostListener('scroll', ['$event'])

    isCollapsed: boolean;
    languages: Array<IDropDownMenu> = [];
    userRole: any;
    defaults: Defaults;
    generalTranslation: IGeneralTranslation;
    showMenuButton = true;
    confirmationStatusEnum = Enums.confirmationStatus;
    constants = Constants;
    userFullName = '';
    modalRef: any;
    private readonly _routerEvents = toSignal(this.router.events);
    private readonly _sessionTimeout = toSignal(this.userPersistenceService.eventCallbackSessionTimeout$);
    private readonly _onVersionChangedForSidebar = toSignal(this.parentChildCommunicationService.on('onVersionChangedForSidebar'));
    private readonly _onPrimaryBuildingTypeChangeFromLeftMenu = toSignal(this.parentChildCommunicationService.on('onPrimaryBuildingTypeChangeFromLeftMenu'));
    private readonly _onPrimaryBuildingTypeChange = toSignal(this.parentChildCommunicationService.on('onPrimaryBuildingTypeChange'));
    private readonly _onPrimaryBuildingTypeReset = toSignal(this.parentChildCommunicationService.on('onPrimaryBuildingTypeReset'));
    private readonly _onUrlChanged = toSignal(this.parentChildCommunicationService.on('onUrlChanged'));
    private readonly _onDashboardClick = toSignal(this.parentChildCommunicationService.on('onDashboardClick'));
    private readonly _onViewChanged = toSignal(this.parentChildCommunicationService.on('onViewChanged'));
    private readonly _onGetVersionDetails = toSignal(this.parentChildCommunicationService.on('onGetVersionDetails'));
    private readonly _onGetFileMenuOptions = toSignal(this.parentChildCommunicationService.on('onGetFileMenuOptions'));
    private readonly _onGetOrganizationData = toSignal(this.parentChildCommunicationService.on('onGetOrganizationData'));
    private readonly _onCloseMenuForProjectStudy = toSignal(this.parentChildCommunicationService.on('onCloseMenuForProjectStudy'));
    firstTimeApplicationLoad = true;
    profileImagePath: any;
    isImageUploaded: boolean;
    confirmationStatus: any = Enums.confirmationStatus;
    isProjectMenu: boolean;
    isNavigationEnd: boolean = false;
    selectedVersion: any;
    versions: any;
    fileMenuOptions: any;
    projectAccess: any;
    otherDetails: any;
    screenHeight: number;
    screenWidth = signal(window.innerWidth);
    displayVersion: string = "2.0.0";
    toolType: any = "Homes";
    toolPage: boolean = false;
    toggleTitle: any;
    changedLanguage = null;
    edgeTrinerAccess: boolean;
    edgeFacultyAccess: boolean;
    isEdgeHomeInspector: boolean;
    isEdgeHomeAuditor: boolean;
    isHpcAdmin: boolean;
    isHpcCountryAdmin: boolean;
    hpcCertifier: boolean;
    sharedHomePrescriptiveProject: boolean;
    isServiceTicketAccess: boolean;
    isEnableServiceRequest: boolean;
    isStaticDashboardAccess: boolean;
    isHPCConfigurationEnable: boolean;
    v3Lang: any = [{
        code: "en",
        key: "English",
        value: "English"
    }];
    savedOrganizationData: any = [];
    isOrganizationData: boolean = false;

    constructor(private router: Router,
        public authservice: AuthService,
        public userPersistenceService: UserPersistenceService,
        private modalService: ModalService,
        private renderer: Renderer2,
        private overlay: Overlay,
        public commonService: CommonService,
        public localStorageService: LocalStorageService,
        private parentChildCommunicationService: ParentChildCommunicationService,
        private toolhelperService: ToolsHelperService,
        private documentUploadDataService: DocumentUploadDataService,
        private _sanitizer: DomSanitizer,
        private deviceService: DeviceDetectorService,
        public commonDataService: CommonDataService,
        private userProfileService: UserProfileService,
        private cdr: ChangeDetectorRef,
    ) {
        this.setDefaults();
        this.onResize();
        effect(() => {
            const version = this._onVersionChangedForSidebar();
            if (version != null) {
                console.log("headerverin");
                this.displayVersion = version.displayVersion;
                if (this.isUndefinedOrNull(version.displayVersion)) {
                    this.displayVersion = version;
                }
                console.log(this.displayVersion);
                console.log(version);
                this.initializeForm();
            }
        });
        effect(() => {
            const toolType = this._onPrimaryBuildingTypeChangeFromLeftMenu();
            if (toolType != null) {
                var QueryParamToolType = localStorage.getItem("QueryParamToolType");
                this.toolType = toolType;
                if (this.toolType === undefined || this.toolType === '') {
                    if (QueryParamToolType == null) {
                        console.log("headerin");
                        this.toolType = 'Homes';
                    } else {
                        this.toolType = QueryParamToolType;
                    }
                }
                this.cdr.markForCheck();
            }
        });
        effect(() => {
            const toolType = this._onPrimaryBuildingTypeChange();
            if (toolType != null) {
                var QueryParamToolType = localStorage.getItem("QueryParamToolType");
                this.toolType = toolType;
                if (this.toolType === undefined || this.toolType === '') {
                    if (QueryParamToolType == null) {
                        console.log("headerin");
                        this.toolType = 'Homes';
                    } else {
                        this.toolType = QueryParamToolType;
                    }
                }
                this.cdr.markForCheck();
            }
        });
        effect(() => {
            const toolType = this._onPrimaryBuildingTypeReset();
            if (toolType != null) {
                var QueryParamToolType = localStorage.getItem("QueryParamToolType");
                this.toolType = toolType;
                if (this.toolType === undefined || this.toolType === '') {
                    if (QueryParamToolType == null) {
                        console.log("headerin");
                        this.toolType = 'Homes';
                    } else {
                        this.toolType = QueryParamToolType;
                    }
                }
                this.cdr.markForCheck();
            }
        });
        effect(() => { const urlChanged = this._onUrlChanged(); if (urlChanged != null) this.toolPage = urlChanged.toolPage; });
        effect(() => {
            if (this._onDashboardClick() != null) {
                this.toolType = "";
            }
        });
        effect(() => { const data = this._onViewChanged(); if (data != null) this.toggleTitle = data.stateOfView ? this.userPersistenceService.generalTranslation.HideIncrementalCost : this.userPersistenceService.generalTranslation.ShowIncrementalCost; });
        effect(() => { const details = this._onGetVersionDetails(); if (details != null) { this.selectedVersion = details.selectedVersion; this.versions = details.versions; } });
        effect(() => { const details = this._onGetFileMenuOptions(); if (details != null) { this.fileMenuOptions = details.fileMenuOptions; this.projectAccess = details.projectAccess; this.otherDetails = details.otherDetails; } });
        effect(() => { if (this._onGetOrganizationData() != null) this.getOrganizationData(); });
        effect(() => { if (this._onCloseMenuForProjectStudy() != null) this.sideMenuClick('menuclose'); });
        effect(() => { if (this._sessionTimeout() != null) this.sessionTimeout(); });
        effect(() => {
            const event = this._routerEvents();

            if (event instanceof NavigationEnd) {
                this.isNavigationEnd = true;

                const currentUrl = event.urlAfterRedirects;

                // Highlight sidenav only when user is inside project pages
                if (currentUrl.includes('/project/')) {
                    const storedToolType =
                        localStorage.getItem('QueryParamToolType');

                    this.toolType = storedToolType || 'Homes';
                } else {
                    // Dashboard and all other pages should have no active building type
                    this.toolType = '';
                }

                if (this.screenWidth() < 768) {
                    this.isProjectMenu =
                        currentUrl.includes('/project') ||
                        currentUrl === '/';
                }

                this.cdr.markForCheck();
            }
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(eve?: any) {
        this.screenWidth.set(window.innerWidth);
        if (this.screenWidth() < 768) {
            if (this.isNavigationEnd && (this.router.url.search('/project') !== -1)) {
                this.isProjectMenu = true;
            }
        } else {
            this.isProjectMenu = false;
        }
    }
    checkVersion() {
        let url = this.router.url;
        if (url.indexOf('project/homes') != -1 || url.indexOf('project/hospitality') != -1 || url.indexOf('project/retail') != -1 || url.indexOf('project/offices') != -1 || url.indexOf('project/hospitals') != -1 || url.indexOf('project/education') != -1) {

            return 'v2.0.0';
        }
        return 'v3.0.0';
    }
    redirect(param: any, menu: string) {

        //return true;
        var paramold = localStorage.getItem("QueryParamToolType");
        //if (param != paramold) {
        //    const modalConfirmRedirectOptions = {
        //        class: 'modal-centre-screen',
        //        ignoreBackdropClick: true,
        //        keyboard: false,
        //        data: {
        //            externalLink: false
        //        }
        //    };
        //    this.modalRef = this.modalService.openModal(ModalBackConfirmationComponent, modalConfirmRedirectOptions);
        //    this.modalRef.content.action.subscribe((result: any) => {
        //        if (result.status === Enums.formDeactivateConfirmStatus.cancel) {
        //            return false;
        //        }

        //    });
        //}

        this.sideMenuClick(menu);
        // Do NOT set QueryParamToolType here. Let the target component decide when
        // to commit the tool type (after confirmation/reset) so the sidenav
        // highlight doesn't change before user confirms navigation away from
        // an existing subproject.
        localStorage.setItem("QueryParamToolTypeold", paramold);
        this.parentChildCommunicationService.publish('onSidebarClick', param);


    }
    isUndefinedOrNull(value): boolean {
        return value === undefined || value === '';
    }


    ngOnInit() {
        if (window.innerWidth >= 768) {
            this.renderer.addClass(document.body, 'sidemenu-collapsed');
        }
        var QueryParamToolType = localStorage.getItem("QueryParamToolType");
        if (QueryParamToolType)
            this.toolType = QueryParamToolType;
        this.toolPage = location.pathname.indexOf('project') != -1 ? true : false;
        this.initializeForm();
        console.log(this.displayVersion);
    }
    getOrganizationData() {
        if (this.authservice.isAuthenticated()) {
            this.userProfileService.GetOrganizationData().subscribe((odata) => {
                this.savedOrganizationData = odata;
            });
        }
    }
    onFileMenuClick($event: any) {
        this.parentChildCommunicationService
            .publish('onFileMenuChanged', { selectedFileMenu: $event });
        this.sideMenuClick('menuclose');
    }

    private checkBrowserVersion(): boolean {
        const browser: string = this.deviceService.browser();
        const arrVersion = this.deviceService.browser_version().split('.');
        const version = +arrVersion[0];
        switch (browser.toLocaleLowerCase()) {
            case 'chrome':
                if (version < 75) {
                    return false;
                }
                break;
            case 'ms-edge':
                if (version < 17) {
                    return false;
                }
                break;
            case 'safari':
                if (version < 12) {
                    return false;
                }
                break;
            case 'firefox':
                if (version < 68) {
                    return false;
                }
                break;
            case 'ie':
                return false;
        }

        return true;
    }

    private handleBrowserError() {
        const modalOptions = {
            class: 'modal-centre-screen',
            ignoreBackdropClick: true,
            keyboard: false,
            data: {}
        };

        this.modalService.openModal(ModalBrowserSupportComponent, modalOptions);
    }

    versionChanged(selectedVersion: any) {
        this.parentChildCommunicationService
            .publish('onVersionChanged', { selectedVersion: selectedVersion });
        this.sideMenuClick('menuclose');
    }

    private initializeForm() {
        const isBrowerCompatible = this.checkBrowserVersion();

        if (!isBrowerCompatible) {
            this.handleBrowserError();
        }

        this.getUserRole();
        if (this.localStorageService.get(Constants.LANGUAGE) != null) {
            this.userPersistenceService.selectedLanguage = this.localStorageService.get(Constants.LANGUAGE);
        } else {
            this.userPersistenceService.selectedLanguage = Constants.ENGLISH;
            this.localStorageService.set(Constants.LANGUAGE, Constants.ENGLISH);
        }
        if (isBrowerCompatible && (window.location.pathname.includes('project-studies') || window.location.pathname.toLowerCase() == '/edge-experts'.toLowerCase())) {

        }
        else if (isBrowerCompatible && !this.authservice.isAuthenticated() && this.localStorageService.get(Constants.IS_LOGIN_DISPLAYED) !== true) {
            if (window.location.pathname.search('/candidate-agreement') === -1 || window.location.pathname.includes('existingProjects')) {
                this.openLoginPopup();
                this.localStorageService.set(Constants.IS_LOGIN_DISPLAYED, true, 120, 'm');
            }
        }
        else if (isBrowerCompatible && this.authservice.isAuthenticated()
            && (window.location.pathname == '/user/login' || window.location.pathname == '/')) {
            let redirectTo = this.authservice.getLandingPage();
            if (redirectTo != null)
                window.location.assign(redirectTo);
            else
                window.location.assign('/project/allBuildings');
        }
        else if (isBrowerCompatible && !this.authservice.isAuthenticated() && (window.location.pathname == '/user/login' || window.location.pathname == '/')) {
            this.openLoginPopup();
        }
        else if (isBrowerCompatible && !this.authservice.isAuthenticated() && window.location.pathname == '/user/register') {
            this.openRegisterModal();
        }
        if (this.changedLanguage != this.userPersistenceService.selectedLanguage) {
            this.changedLanguage = this.userPersistenceService.selectedLanguage;
            this.getAllLanguages();
            this.getTraslationForGeneralPages();
            this.getTraslationForValidationMessages();
            this.cdr.markForCheck();
        }
        this.setInitialImage();
        this.cdr.markForCheck();
    }

    ngAfterViewInit() {
    }

    sideMenuClick(menu: string) {
        this.parentChildCommunicationService
            .publish('onAutoCalculateChanged', { isAutoCalculate: this.localStorageService.get('autoCalculate') });
        if (menu === 'menuexpand') {
            this.renderer.removeClass(document.body, 'sidemenu-collapsed');
            this.renderer.removeClass(document.body, 'sidemenu-expanded');
            this.renderer.removeClass(document.body, 'sidemenu-hidden');
            this.renderer.addClass(document.body, 'sidemenu-arrowexpanded');
        } else if (menu === 'collapsed') {
            this.renderer.removeClass(document.body, 'sidemenu-expanded');
            this.renderer.removeClass(document.body, 'sidemenu-arrowexpanded');
            this.renderer.removeClass(document.body, 'sidemenu-hidden');
            if (window.innerWidth >= 768) {
                this.renderer.addClass(document.body, 'sidemenu-collapsed');
            }
        } else if (menu === 'menuclose') {
            this.renderer.removeClass(document.body, 'sidemenu-collapsed');
            this.renderer.removeClass(document.body, 'sidemenu-expanded');
            this.renderer.removeClass(document.body, 'sidemenu-arrowexpanded');
            this.renderer.addClass(document.body, 'sidemenu-hidden');
            this.showMenuButton = true;
        }
    }

    showSidenave() {
        if (this.showMenuButton) {
            this.renderer.removeClass(document.body, 'sidemenu-collapsed');
            this.renderer.removeClass(document.body, 'sidemenu-hidden');
            this.renderer.addClass(document.body, 'sidemenu-expanded');
            this.showMenuButton = false;
        } else {
            this.sideMenuClick('collapsed');
            this.sideMenuClick('menuexpand');
        }
    }

    overlayClick() {
        this.renderer.removeClass(document.body, 'sidemenu-expanded');
        this.renderer.removeClass(document.body, 'sidemenu-arrowexpanded');
        this.renderer.removeClass(document.body, 'sidemenu-hidden');
        if (window.innerWidth >= 768) {
            this.renderer.addClass(document.body, 'sidemenu-collapsed');
        }
    }

    private setDefaults() {
        this.defaults = new Defaults();
        this.generalTranslation = this.defaults.generalTranslations;
        this.userPersistenceService.generalTranslation = this.defaults.generalTranslations;
    }

    private getAllLanguages() {
        this.authservice.getLanguages().subscribe((response) => {
            this.languages = response;
        },
            (err: any) => console.error('this.authservice.getLanguages()', err));
    }

    private getUserRole() {
        this.userRole = this.authservice.getUserRole();
        this.cdr.markForCheck();
    }

    onUserMenuOpened() {
        const trigger = this.profileMenuTrigger;
        if (trigger) {
            const overlayRef = (trigger as any)._overlayRef;
            if (overlayRef) {
                // Measure the actual rendered navbar bottom so the dropdown
                // sits just below the navbar on every screen size.
                const navEl = document.querySelector('nav.ifc-header') as HTMLElement;
                const navBottom = navEl ? Math.ceil(navEl.getBoundingClientRect().bottom) : 56;
                // Expose as CSS variable so the max-height cap in stylesheet stays in sync.
                document.documentElement.style.setProperty('--user-menu-top', `${navBottom}px`);
                // Position the menu and force height to extend to bottom of page
                const strategy = this.overlay.position()
                    .global()
                    .top(`${navBottom}px`)
                    .right('0px');
                overlayRef.updatePositionStrategy(strategy);
                overlayRef.updatePosition();

                // Let the panel size to its content — measure it after Angular renders it
                setTimeout(() => {
                    const overlayPane = overlayRef.overlayElement;
                    const menuPanel = overlayPane?.querySelector('.user-profile-menu') as HTMLElement;
                    const menuContent = menuPanel?.querySelector('.mat-mdc-menu-content, .mat-menu-content') as HTMLElement;

                    const maxH = window.innerHeight - navBottom;

                    // Remove any forced full-height — let content drive the height
                    if (overlayPane) {
                        overlayPane.style.removeProperty('height');
                        overlayPane.style.removeProperty('min-height');
                        overlayPane.style.maxHeight = `${maxH}px`;
                        // Keep overflow visible so panel elevation is not clipped.
                        overlayPane.style.overflow = 'visible';
                    }

                    if (menuPanel) {
                        menuPanel.style.removeProperty('height');
                        menuPanel.style.removeProperty('min-height');
                        menuPanel.style.maxHeight = `${maxH}px`;
                        // Menu content itself handles scroll; keep panel overflow visible for shadow.
                        menuPanel.style.overflow = 'visible';
                    }

                    if (menuContent) {
                        menuContent.style.removeProperty('height');
                        menuContent.style.removeProperty('min-height');
                        menuContent.style.maxHeight = `${maxH}px`;
                        menuContent.style.overflowY = 'auto';
                        menuContent.style.overflowX = 'hidden';
                    }

                    // Re-inject <style> tag as the LAST child of <head> on every open.
                    // Angular Material lazily injects <style> tags so we must always
                    // be last in source order to win the cascade.
                    const STYLE_ID = 'edge-hide-profile-scrollbar';
                    let tag = document.getElementById(STYLE_ID);
                    if (tag) { tag.remove(); }
                    tag = document.createElement('style');
                    tag.id = STYLE_ID;
                    const sels = [
                        '.cdk-overlay-pane:has(.user-profile-menu)',
                        '.user-profile-menu',
                        '.user-profile-menu.mat-mdc-menu-panel',
                        '.user-profile-menu .mat-mdc-menu-content',
                        '.user-profile-menu .mat-menu-content',
                        '.user-profile-menu *'
                    ];
                    tag.textContent =
                        sels.join(',') +
                        '{scrollbar-width:none!important;-ms-overflow-style:none!important;overflow:-moz-scrollbars-none!important}' +
                        sels.map(s => s + '::-webkit-scrollbar').join(',') +
                        '{width:0!important;height:0!important;display:none!important;background:transparent!important}' +
                        sels.map(s => s + '::-webkit-scrollbar-thumb').join(',') +
                        '{display:none!important;background:transparent!important}' +
                        sels.map(s => s + '::-webkit-scrollbar-track').join(',') +
                        '{display:none!important;background:transparent!important}';
                    document.head.appendChild(tag);
                }, 0);
            }
        }
    }

    onUserMenuClosed() {
    }

    loginOrOut() {

        if (this.authservice.isAuthenticated()) {
            this.router.navigate(['/user/logout']);
        } else {
            this.openLoginPopup();
        }
    }

    private logout() {
        this.authservice.logout()
            .subscribe((status: boolean) => {
                this.authservice.reloadPage();
            },
                (err: any) => console.log(err));
    }

    setInitialImage(onData?: (data: any) => void) {
        if (this.authservice.isAuthenticated()) {
            this.authservice.getUserInfo().subscribe(data => {
                this.localStorageService.set('autoCalculateProfile', false);
                this.edgeTrinerAccess = data.isEdgeTrainer;
                this.localStorageService.set("edgeTrinerAccess", this.edgeTrinerAccess);
                this.edgeFacultyAccess = data.isEdgeFaculty;
                this.localStorageService.set("edgeFacultyAccess", this.edgeFacultyAccess);
                this.isEdgeHomeInspector = data.isEdgeHomeInspector;
                this.isEdgeHomeAuditor = data.isEdgeHomeAuditor;
                this.isHpcAdmin = data.isHpcAdmin;
                this.isHpcCountryAdmin = data.isHpcCountryAdmin;

                this.hpcCertifier = data.isHpcCertifier;
                this.sharedHomePrescriptiveProject = data.sharedHomePrescriptiveProject;
                this.localStorageService.set("isRegisterAccess", data.isRegisterAccess);
                this.isHPCConfigurationEnable = data.isHPCConfigurationEnable;
                this.isServiceTicketAccess = data.isServiceTicketAccess;
                this.isStaticDashboardAccess = data.isStaticDashboardAccess;
                this.isEnableServiceRequest = data.isEnableServiceRequest;
                this.isImageUploaded = data.profileImageUploaded;
                this.isOrganizationData = data.isOrgAdmin;
                this.localStorageService.set('autoCalculate', data.isAutoCalculateEnabled);
                if (this.isImageUploaded) {
                    this.authservice.getUserProfileImage().subscribe(
                        data => {
                            this.profileImagePath = data === null ?
                                this.setDefaultImage() : this._sanitizer
                                    .bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + data);
                        },
                        error => {
                            this.profileImagePath = this.setDefaultImage();
                        });

                } else {
                    this.profileImagePath = this.setDefaultImage();
                }
                this.cdr.markForCheck();
                if (onData) { onData(data); }
            });
        } else {
            this.profileImagePath = this.setDefaultImage();
        }

        this.userFullName =
            this.localStorageService.get(Constants.USER_FULL_NAME) || '';

        this.cdr.markForCheck();
    }

    setDefaultImage(): string {
        return 'assets/images/sample-auditor-image.png';
    }

    openLoginPopup() {
        this.modalRef = this.modalService.openLoginModalIfNotAuthenticate();

        this.modalRef.content.action.subscribe((result: any) => {
            // Flag removed after 120 minute
            this.localStorageService.set(Constants.IS_LOGIN_DISPLAYED, true, 120, 'm');
            this.modalRef.hide();
            if (result.status === this.confirmationStatusEnum.ok) {
                const userPasswordReset = result.response.userPasswordReset === 'true';
                const passwordExpired = result.response.passwordExpired === 'true';
                if (window.location.pathname.search('/candidate-agreement') !== -1) {
                    window.location.reload();
                    return;
                }
                this.getUserRole();
                this.setInitialImage((data) => {
                    this.parentChildCommunicationService
                        .publish('onAutoCalculateChanged', { isAutoCalculate: data.isAutoCalculateEnabled });
                    if (data.isUserDeleted) {
                        this.logout();
                    }
                    if (data.hideLandingPagePopUp == false) {
                        this.openLandingPagePreferenceModal(data.landingPageName);
                    }
                    if (userPasswordReset || passwordExpired) {
                        this.openChangePasswordModal(passwordExpired, userPasswordReset);
                    }
                });

            }
            else if (result.status === 'LMSPortal') {
                const userPasswordReset = result.response.userPasswordReset === 'true';
                const passwordExpired = result.response.passwordExpired === 'true';
                if (window.location.pathname.search('/LMS') !== -1) {
                    window.location.reload();
                    return;
                }
                this.getUserRole();
                this.setInitialImage();
                if (userPasswordReset || passwordExpired) {
                    this.openChangePasswordModal(passwordExpired, userPasswordReset);
                }

                let LMSURL = this.localStorageService.get('lmsRedirectURL');
                window.location.href = LMSURL + '&code=' + + result.response.access_token + '&grant_type=authorization_code';
                //var LMSURL = environment.LMSURL_SEO;
                ////https://uat.edgebuildings.com/project/homes?client_id=RURHRUxNU0ludGVncmF0aW9u&response_type=code&redirect_uri=https:%2F%2Fifc.hubblestudios.co.za%2Fadmin%2Foauth2callback.php&state=%2Fauth%2Foauth2%2Flogin.php%3Fwantsurl%3Dhttps%253A%252F%252Fifc.hubblestudios.co.za%252F%26sesskey%3D3TUNUwEEPZ%26id%3D4&scope=openid%20profile%20email
                //window.location.href = LMSURL+'?Name=' + result.response.access_token;
            } else if (result.status === 'registerClick') {
                this.router.navigate(['/user/register'])
                this.openRegisterModal();
            } else if (result.status === 'forgotPassword') {
                this.openForgotPasswordModal();
            }
            else if (result.status === 'Guest') {
                if (this.router.url != '/project/allBuildings')
                    window.location.assign('/project/allBuildings');
                //else
                //    this.router.navigate(['/project/allBuildings']);
            }
        });
    }

    openLandingPagePreferenceModal(landingPageName: string) {
        var LandingPageDropDown = [
            { key: "CreateNew", text: "Create New", category: null },
            { key: "Profile", text: "Profile", category: null }
        ];
        switch (this.userRole) {
            case Enums.Role.Client:
                LandingPageDropDown.push({ key: "ClientDashboard", text: "Dashboard", category: null });
                break;
            case Enums.Role.Auditor:
                LandingPageDropDown.push({ key: "AuditorDashboard", text: "Dashboard", category: null });
                break;
            case Enums.Role.Reviewer:
                LandingPageDropDown.push({ key: "ReviewerDashboard", text: "Dashboard", category: null });
                break;
            case Enums.Role.CertifierAdmin:
                LandingPageDropDown.push({ key: "CertifierAdminDashboard", text: "Dashboard", category: null });
                LandingPageDropDown.push({ key: "EDGEExpertsandAuditors", text: "EDGE Experts and Auditors", category: null });
                break;
            case Enums.Role.CountryAdmin:
                LandingPageDropDown.push({ key: "CountryAdminDashboard", text: "Dashboard", category: null });
                LandingPageDropDown.push({ key: "ExistingProjects", text: "Existing Projects", category: null });
                LandingPageDropDown.push({ key: "DirectoryofEDGEExperts", text: "Directory of EDGE Experts", category: null });
                break;
            case Enums.Role.Administrator:
                LandingPageDropDown.push({ key: "AdministratorDashboard", text: "Dashboard", category: null });
                LandingPageDropDown.push({ key: "ExistingProjects", text: "Existing Projects", category: null });
                LandingPageDropDown.push({ key: "EDGEExam", text: "EDGE Exam", category: null });
                LandingPageDropDown.push({ key: "EDGEExpertsandAuditors", text: "EDGE Experts and Auditors", category: null });
                LandingPageDropDown.push({ key: "UserRoleConfiguration", text: "User Role Configuration", category: null });
                LandingPageDropDown.push({ key: "HPCPartnerConfiguration", text: "HPC Partner Configuration", category: null });
                /*LandingPageDropDown.push({ key: "DownloadStatistics", text: "Download Statistics", category: null });*/
                LandingPageDropDown.push({ key: "NotificationCenter", text: "Notification Center", category: null });
                LandingPageDropDown.push({ key: "ServiceRequest", text: "Service Request", category: null });
                LandingPageDropDown.push({ key: "VersionManagement", text: "Version Management", category: null });
                break;
        }
        if ((this.edgeTrinerAccess || this.edgeFacultyAccess) && this.userRole != Enums.Role.Administrator) {
            LandingPageDropDown.push({ key: "EDGEExam", text: "EDGE Exam", category: null });
            if (this.userRole != Enums.Role.CertifierAdmin && this.userRole != Enums.Role.CountryAdmin && this.userRole != Enums.Role.Administrator)
                LandingPageDropDown.push({ key: "DirectoryofEDGEExperts", text: "Directory of EDGE Experts", category: null });
        }

        const modalOptions = {
            class: 'modal-centre-screen',
            ignoreBackdropClick: true,
            keyboard: false,
            data: {
                landingPageDropDown: LandingPageDropDown,
                landingPageName: landingPageName
            }
        };

        this.modalRef = this.modalService.openModal(ModalLandingPagePreference, modalOptions);

        this.modalRef.content.action.subscribe((result: any) => {
            if (result.status === this.confirmationStatusEnum.ok) {
                this.router.navigate([result.data]);
            }
        });
    }

    openRegisterModal() {
        const modalSignupOptions = {
            class: 'd-flex justify-content-center align-items-center modal-90',
            data: {
                nextButton: 'Next',
                getstartedButton: 'Get Started',
                Login: 'Login'
            }
        };

        this.modalRef = this.modalService.openModal(ModalSignupComponent, modalSignupOptions);

        this.modalRef.content.action.subscribe((result: any) => {
            if (result.status === this.confirmationStatusEnum.ok) {
                this.modalRef.hide();
                this.userRole = Enums.Role.Client;
                // Refresh header after successful registration
                this.setInitialImage();
                this.cdr.markForCheck();
                this.openLandingPagePreferenceModal('ClientDashboard');
            } else if (result.status === 'loginClick') {
                this.modalRef.hide();
                this.router.navigate(['/user/login']);
                this.openLoginPopup();
            }
        });
    }

    openForgotPasswordModal() {
        const modalOptions = {
            class: 'modal-centre-screen',
            ignoreBackdropClick: true,
            keyboard: false,
            data: {}
        };

        this.modalRef = this.modalService.openModal(ModalForgotPasswordComponent, modalOptions);

        this.modalRef.content.action.subscribe((result: any) => {
            if (result.status === 'login') {
                this.openLoginPopup();
            }
        });
    }

    openChangePasswordModal(isPasswordExpired: boolean, userPasswordReset: boolean) {
        const modalOptions = {
            class: 'modal-centre-screen',
            ignoreBackdropClick: true,
            keyboard: false,
            data: {
                userPasswordReset: userPasswordReset,
                passwordExpired: isPasswordExpired
            }
        };

        this.modalRef = this.modalService.openModal(ModalChangePasswordComponent, modalOptions);

        this.modalRef.content.action.subscribe((result: any) => {
            if (result.status === 'login') {
                this.openLoginPopup();
            } else if (result.status === this.confirmationStatusEnum.cancel && isPasswordExpired) {
                this.logout();
            }
        });
    }

    sessionTimeout() {
        const modalOptions = {
            class: 'modal-centre-screen',
            ignoreBackdropClick: true,
            keyboard: false,
            data: {
                okButton: this.userPersistenceService.generalTranslation.PopupYes,
                cancelButton: this.userPersistenceService.generalTranslation.PopupNo
            }
        };

        this.modalRef = this.modalService.openModal(ModalSessionTimeoutComponent, modalOptions);

        this.modalRef.content.action.subscribe((result: any) => {
            if (result.status === Constants.REFRESH_TOKEN) {
                this.authservice.refreshToken()
                    .subscribe((status: boolean) => {
                    },
                        (err: any) => console.log(err));

            } else {
                if (this.authservice.isAuthenticated()) {
                    this.logout();
                } else {
                    this.authservice.reloadPage();
                }
            }
        });
    }

    onLanguageChange(event: { key: string; }) {
        this.localStorageService.set(Constants.LANGUAGE, event.key);
        this.userPersistenceService.selectedLanguage = event.key;
        this.getTraslationForGeneralPages(true);
        this.getTraslationForValidationMessages();
    }

    openPrometric() {
        this.router.navigate(['/prometric/all-exam-candidates']);
    }
    openPrometricForTrainer() {
        this.router.navigate(['/prometric/all-exam-candidates']);
    }

    openDirectoryOfEdgeExpert() {
        this.router.navigate(['/prometric/edge-experts-directory']);
    }

    openEdgeExpertAndAuditor() {
        this.router.navigate(['/prometric/edge-experts-directory']);
    }

    openUserRoleConfig() {
        this.router.navigate(['/user/list']);
    }

    openHpcRoleConfig() {
        this.router.navigate(['/user/hpclist']);
    }

    openHpcPartnerConfig() {
        this.router.navigate(['/user/hpc-partner-configuration']);
    }

    openDownloadStatistics() {
        this.router.navigate(['/admin/statistics']);
    }

    openMyProject() {
        switch (this.userRole) {
            case Enums.Role.CountryAdmin:
            case Enums.Role.Administrator:
                this.router.navigate(['/project/existingProjects']);
                break;
            default:
                break;
        }
    }

    openUserProfile() {
        this.router.navigate(['/user/profile']);
    }

    navigateToAlphaSite() {
        this.router.navigate(['/user/externalLink']);
    }

    navigateToWordpress() {
        this.router.navigate(['/user/wordpress']);
    }

    onNotificationCenterClick() {
        this.router.navigate(['/admin/notifications-center']);
    }

    private getTraslationForGeneralPages(source = false) {
        this.authservice.languageChanged(this.userPersistenceService.selectedLanguage)
            .subscribe((result: any) => {
                this.generalTranslation = result;
                if (this.generalTranslation?.Copyright) {
                    this.generalTranslation.Copyright = this.generalTranslation.Copyright.replace(/\b20\d{2}\b/, new Date().getFullYear().toString());
                }
                this.userPersistenceService.generalTranslation = result;
                // emit events
                if (!this.firstTimeApplicationLoad) {
                    this.parentChildCommunicationService
                        .publish('onLanguageChanged', { selectedLanguage: this.userPersistenceService.selectedLanguage, 'source': source });
                }
                this.toggleTitle = this.localStorageService.get('incrementCostView') ? this.userPersistenceService.generalTranslation.HideIncrementalCost : this.userPersistenceService.generalTranslation.ShowIncrementalCost;
                this.firstTimeApplicationLoad = false;
                this.cdr.markForCheck();
            }, (err: any) => console.log(err));
    }

    private getTraslationForValidationMessages() {
        this.authservice.getValidationMessages(this.userPersistenceService.selectedLanguage)
            .subscribe((result: any) => {
                this.userPersistenceService.validationMessages = result;
            }, (err: any) => console.log(err));
    }

    openImageCropper() {
        const params = {
            isImageUploaded: this.isImageUploaded,
            image: this.profileImagePath,
            heading: this.userPersistenceService.generalTranslation.ProfileImage
        };
        this.modalRef = this.toolhelperService.opnImageCropper(params);
        this.modalRef.content.action.subscribe((result: any) => {
            if (result.status === this.confirmationStatusEnum.ok) {
                this.documentUploadDataService.saveProfileImage(result.value)
                    .subscribe(((data) => {
                        this.isImageUploaded = true;
                        this.setProfileImagePath(true);
                    }));
            } else if (result.status === this.confirmationStatusEnum.remove) {
                this.documentUploadDataService.removeProfileImage()
                    .subscribe(((data) => {
                        this.isImageUploaded = false;
                        // this.form.get('projImageUploaded').setValue(false);
                        this.setProfileImagePath(false);
                    }));
            }
        });
    }

    setProfileImagePath(isImageUploaded: boolean): void {
        if (!isImageUploaded) {
            this.isImageUploaded = false;
            this.profileImagePath = this.setDefaultImage();
            this.cdr.markForCheck();
            return;
        }

        this.isImageUploaded = true;

        this.authservice.getUserProfileImage()
            .subscribe({
                next: (path: any) => {
                    this.profileImagePath = path === null ?
                        this.setDefaultImage() : this._sanitizer
                            .bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + path);

                    this.cdr.markForCheck();
                },
                error: () => {
                    this.isImageUploaded = false;
                    this.profileImagePath = this.setDefaultImage();
                    this.cdr.markForCheck();
                }
            });
    }

    onDashboardClick() {
        this.commonService.openDashboard(this.authservice);
        this.sideMenuClick('menuclose');
    }

    onScrollClick() {
    }

    ServiceRequest() {
        this.router.navigate(['/user/service-ticket']);
    }
    openDatabase() {
        this.router.navigate(['/database-admin/database']);
    }
    navigateToOrganization() {
        this.router.navigate(['/organization']);
    }
    // Adding VersionManagement as Delta Change from UI_PROD_28JUN20266
    VersionManagement() {
        this.sideMenuClick('menuclose');
        this.router.navigate(['/dashboard/version-management']);
    }
}


